const path = "insights/mb-filter-row";

export const SET_SELECTED_COMPETITORS = `${path}/SET_SELECTED_COMPETITORS`;
export const SET_SELECTED_TIME_FREQUENCY = `${path}/SET_SELECTED_TIME_FREQUENCY`;
export const SET_SELECTED_DATE_RANGE = `${path}/SET_SELECTED_DATE_RANGE`;
export const SET_MAX_DATE = `${path}/SET_MAX_DATE`;
export const SET_CHOSEN_PERIOD = `${path}/SET_CHOSEN_PERIOD`;
export const SET_COMPARE_PERIOD = `${path}/SET_COMPARE_PERIOD`;
export const SET_PREVIOUS_SELECTED_DATE_RANGE = `${path}/SET_PREVIOUS_SELECTED_DATE_RANGE`;
